import { Component, OnInit, Input } from '@angular/core';
import { BaseControl } from 'src/app/models/base-control';

@Component({
  selector: 'app-tool-tip-validation',
  templateUrl: './tool-tip-validation.component.html',
  styleUrls: ['./tool-tip-validation.component.scss']
})
export class ToolTipValidationComponent extends BaseControl implements OnInit {

  @Input() controlType: string = null;


  ngOnInit() {
    if (this.config.ControlType == "ComboBox" ||
      this.config.ControlType == "MultiComboBox" || this.config.ControlType == "FileBox") {
     
      this.controlType = this.config.ControlType;
    }
  }


  // validar() {
  //   debugger;
  //   return this.controlType == 'FileBox' && this.config.Required && (this.modelo == null || this.modelo.length == 0)
  // }

  ngAfterViewInit() {
    //(<any>$('[data-toggle="tooltip"]')).tooltip();
    //$('[data-toggle="tooltip"]').tooltip();
    // (<any>$('[data-toggle="tooltip"]')).tooltip({
    //   sanitizeFn: function (content) { return content; }
    // });
  }

}
